module.exports = __webpack_public_path__ + "img/f07448f.png";